import { REHYDRATE } from "redux-persist";
import get from "lodash.get";

import ContractActionTypes from "services/contract/types";
import AuthenticationActionTypes from "services/authentication/types";
import GlobalFiltersActionTypes from "services/globalFilters/types";
import initialState from "./initialState";

const GlobalFiltersReducer = (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      // we only keep the duration from filters, we reset everything else
      return {
        ...initialState,
        duration: get(
          action,
          "payload.GlobalFilters.duration",
          initialState.duration
        ),
      };
    case AuthenticationActionTypes.LOG_OUT:
    case ContractActionTypes.SWITCH_CONTRACT:
      return initialState;
    case GlobalFiltersActionTypes.SET_PARAMETER:
      return {
        ...state,
        [action.key]: action.value,
      };
    case GlobalFiltersActionTypes.SET_SELECTED_FILTERS:
      return {
        ...state,
        selectedFilters: action.value,
      };
    // LIST OF FILTERS FROM API
    case GlobalFiltersActionTypes.SET_FILTERS:
      return {
        ...state,
        filters: action.value,
      };
    default:
      return state;
  }
};

export default GlobalFiltersReducer;
